import React from 'react';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Alert, Button, List, Modal, theme } from 'antd';

import { MultiStepResults } from '@totem/components/services/remoteAccess/auth0users/details/types';
import ModalFooter from '@totem/components/ui_components/dialogs/ModalFooter';
import ModalTitle from '@totem/components/ui_components/dialogs/ModalTitle';

type Props = {
  visible: boolean;
  title: string;
  result: MultiStepResults | null;
  successMessage: string;
  failureMessage: string;
  onClose: () => void;
};

const StepResultsModal = ({
  visible,
  title,
  result,
  successMessage,
  failureMessage,
  onClose,
}: Props) => {
  const { token } = theme.useToken();

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      title={<ModalTitle>{title}</ModalTitle>}
      styles={{ body: { maxHeight: '80vh', overflowY: 'auto' } }}
      footer={
        <ModalFooter>
          <Button type="primary" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      }
    >
      <Alert
        style={{ marginBottom: 16 }}
        type={result?.success ? 'success' : 'error'}
        showIcon
        message={result?.success ? successMessage : failureMessage}
        description={result?.error || undefined}
      />

      <List
        size="small"
        bordered
        dataSource={result?.steps ?? []}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
              avatar={
                item.success ? (
                  <CheckCircleOutlined style={{ color: token.colorSuccess }} />
                ) : (
                  <CloseCircleOutlined style={{ color: token.colorError }} />
                )
              }
              title={item.stepName}
              description={item.error || item.outcome}
            />
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default StepResultsModal;
